// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"94032f27","421":"ece1a5b9","583":"ba55f13a","601":"75b687fe","808":"1d50f159","891":"8f859fb5","918":"3856d532"}[chunkId] + ".chunk.css";
};